import React, { useState, useEffect, useMemo } from "react";
import Translations from "../../services/translation.service";
import Call from "../../assets/img/stm-call.svg";
import Data from "../../assets/img/stm-data.svg";

import Wallet from "../../assets/img/stm-wallet.svg";
import Tag from "../../assets/img/stm-tag.png";
import SummaryOfferSection from "./storefront-summary-offers-section";
import Summaries from "../../services/summaries.service";
import storefront from "../../services/storefront.service";
import Storage from "../../services/storage.service";
import StmSummarySkeleton from "../../views/skeleton/storefront-summary";
import Plans from "../../services/plans.service";
import FirebaseAnalytics from "../../services/analytics.service";
import * as variables from '../../variables';
import ModalWrapper from "./modal-wrapper";
import ContentSlider from "./contentSlider";
import Bulb from "../../assets/img/stm-payment-bulb.svg";
import Helpers from "../../helpers/shared.helper";
import StmSummaryAmanFeatureRows from "./stm-summary-aman-feature-rows.component";
import AvailableCountries from "../planSelection/available-countries";
import EgyptFlexSummaryPlan from "./egyptFlexSummaryPlan";
import planFG from "../../services/planFg.service";

const subscriptions = [];
let prefix = "stm_sum_";
let prefix_general = "stm_general_";

const StmSummary = ({
  appliedOffer,
  setAppliedOffer,
  selectedCard,
  selectedDataPlanData,
  selectedTimePlanData,
  selectedSMSPlanData,
  isBuildOwnPlan,
  setOffersFetchedInitially = () => { },
  socFirebaseEventParamsOnToggle = {},
  socFirebaseEventParamsOnApply = {},
  socFirebaseEventParamsOnError = {}
}) => {
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [loader, setLoader] = useState(true);
  const [numberData, setNumberData] = useState(null);
  const [savedPlans, setSavedPlans] = useState([]);
  const [savedPlanBundle, setSavedPlanBundle] = useState(null);
  const [flexiCountries, setFlexiCountries] = useState([]);
  const [planPromotions, setPlanPromotions] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [planCode, setPlanCode] = useState("");
  const [planPrice, setPlanPrice] = useState(0);
  const [planPdfsKeys, setPlanPdfsKeys] = useState(JSON.parse(Storage.get('citcPdfForPlans', true)) || {});
  const [openModal, setOpenModal] = useState(false);
  const [infoModalDetails, setInfoModalDetails] = useState({
    imagesFolder: "",
    sliderData: [],
  });
  const [pdfPlanIDs, setPdfPlanIDs] = useState("");

  const handleModal = (e) => {
    e.stopPropagation();
    setOpenModal((prev) => !prev);
  };

  const getSliderData = (modalKey) => {
    const poModalKey = modalKey;
    let business = Storage.get("business", true);
    let poModalData = null;
    if (business) {
      business = JSON.parse(business);
      if (business[poModalKey]) {
        poModalData = business[poModalKey]
      }
    }
    return poModalData
  }

  const handleModalData = (e, type) => {
    const sliderData = getSliderData(type);
    if (sliderData) {
      setInfoModalDetails({
        "imagesFolder": "information_popup_images",
        "sliderData": sliderData
      });
      handleModal(e);
    }
    let event_label = "";
    // Firebase Analytics Events
    switch (type) {
      case "advance_payment_popup_json":
        FirebaseAnalytics.about_advance_payment_info();
        event_label = "advance_screen"
        break;
      case "deposit_payment_popup_json":
        FirebaseAnalytics.about_deposit_payment_info();
        event_label = "deposit_screen"
        break;
      case "credit_limit_popup_json":
        FirebaseAnalytics.about_credit_limit_info();
        event_label = "credit_screen"
        break;
      default:
        break;
    }

    if(event_label) {
      commonRecordFirebaseEvent({ event_category: "onboarding_payment", event_screen: "payment_summary", event_label: event_label, interaction_type: "click" });
    }
  };

  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);

  const getPlanName = (plan_code) => {
    const planCode = plan_code?.replaceAll("-", "_")?.replaceAll(" ", "")?.replaceAll(",", "")?.toLowerCase();
    let plan_prefix = "general_plan_name_";
    if (planCode) {
      return Translations.keys[plan_prefix + planCode];
    }
  };



  const getSummary = () => {
    return Summaries.getSummary()
      .then((res) => {
        setLoader(false);
        if (res?.data) {
          Storage.set("summaryLoaded", true);
          setSummaryData(res?.data);
          Storage.set("paymentPrice", res?.data?.total_amount_vat_included, true);
          Storage.set("enable_pay_later", res?.data?.enable_pay_later, true);
          Storage.set("enable_pay_now", res?.data?.enable_pay_now, true);
          const saved_plans = res?.data?.saved_plans[0];
          if (saved_plans && saved_plans["Plans"]?.length) {
            const flexiCountries = saved_plans["Plans"].filter(plan => plan.Type === variables.PROMOTION_TYPE_VOICE_FLEXI);
            if(flexiCountries[0]?.Countries?.length > 0) {
              setFlexiCountries(flexiCountries[0]?.Countries);
            }
            setSavedPlanBundle(saved_plans);
            setPlanCode(saved_plans["PlanCode"]);
            setSavedPlans(saved_plans["Plans"]);
            setPlanPromotions(saved_plans["PlanPromotions"] || []);
            setPlanPrice(saved_plans["DiscountedPrice"]);

          }
          if (res?.data?.number_details) {
            setNumberData(res?.data?.number_details);
            if (res.data.number_details.MSISDN) {
              Storage.set("number", res.data.number_details.MSISDN, true);
              Storage.set("num_vanity", res.data.number_details.VanityLevelID, true);
            }
          }
        }
        commonRecordFirebaseEvent({ event_category: 'onboarding_sim_delivery_selection', event_screen: "sim_delivery", event_label: "package_card", interaction_type: "view" });
      })
      .catch(() => {
        setLoader(false);
      });
  }

  useEffect(() => {
    getSummary();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const sortPlanPDFs = (pdfs) => {
    const sortedObj = {};
    Object.keys(pdfs).forEach((key) => {
      const sortedKey = key.split(',').sort((a, b) => a - b).join(',');
      sortedObj[sortedKey] = pdfs[key];
    })
    return sortedObj;
  }

  useEffect(() => {
    Storage.get_obsrv("citcPdfForPlans").subscribe(data => {
      if (data) {
        setPlanPdfsKeys(JSON.parse(data));
      } else if (!Storage.get("fetching_citcPdfForPlans")) {
        Storage.set("fetching_citcPdfForPlans", true);
        setLoader(true);
        Plans.getCITC().then((res) => {
          setLoader(false);
          Storage.clear("citcErrorStatus");
          if (res?.data) {
            setPlanPdfsKeys(sortPlanPDFs(res?.data));
            Storage.set(
              "citcPdfForPlans",
              JSON.stringify(sortPlanPDFs(res?.data)),
              true
            );
          }
        }).catch(() => {
          setLoader(false);
          Storage.clear("citcErrorStatus");
        }).finally(() => {
          Storage.clear("fetching_citcPdfForPlans");
        })
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const normalizePDFs = inputObj => {
    const obj = {};

    for (const key in inputObj) {
        if (Object.hasOwnProperty.call(inputObj, key)) {
            const formattedKey = key.replace(/,\s*/g, ','); // Remove spaces after commas
            const value = inputObj[key];
            obj[formattedKey] = value;
        }
    }

    return obj;
  }

  const pdfMatcher = (planIds) => {
    const numbersArray = planIds.split(',');
    const sortedArray = numbersArray.map(Number).sort((a, b) => a - b);
    const sortedString = sortedArray.join(',');
    return sortedString
  }

  const pdfUrl = useMemo(() => {
    const selectedPlanIds = Storage.get("selected_plan_id", true)
    let cardMatchingKeys = "";
    // For Predefined Plans
    if (selectedCard?.Plan?.length) {
      const collectPlanIDs = [];
      selectedCard.Plan.forEach(item => {
        collectPlanIDs.push(item?.PlanID);
      });
      cardMatchingKeys = collectPlanIDs.toSorted();
      cardMatchingKeys = cardMatchingKeys.join(",");
    }
    // For Custom Plans
    if (isBuildOwnPlan) {
      const collectPlanIDs = [];
      if (selectedDataPlanData) {
        collectPlanIDs.push(selectedDataPlanData?.ID);
      }
      if (selectedTimePlanData) {
        collectPlanIDs.push(selectedTimePlanData?.ID);
      }
      if (selectedSMSPlanData) {
        collectPlanIDs.push(selectedSMSPlanData?.ID);
      }
      cardMatchingKeys = collectPlanIDs.toSorted();
      cardMatchingKeys = cardMatchingKeys.join(",");
    }
    // For Cachcing
    if (selectedPlanIds) {
      const collectPlanIDs = selectedPlanIds.split(",")
      cardMatchingKeys = collectPlanIDs.toSorted();
      cardMatchingKeys = cardMatchingKeys.join(",");
    }
    const cardToMatch = pdfMatcher(cardMatchingKeys);
    const updatedPlanPdfsKeys = normalizePDFs(planPdfsKeys);
    if(cardToMatch) {
      setPdfPlanIDs(cardToMatch)
    }
    const pdfFile = updatedPlanPdfsKeys[`${cardToMatch}`] ? updatedPlanPdfsKeys[`${cardToMatch}`] : null;
    return pdfFile
  }, [selectedCard, planPdfsKeys, isBuildOwnPlan, selectedDataPlanData, selectedTimePlanData, selectedSMSPlanData])

  const numberType = useMemo(() => {
    return translationKeys[`general_vanity_name_${numberData?.VanityLevelID || 0}number`]
  }, [numberData, translationKeys])

  const { addonsValues, dataBonusValues, minutesBonusValues, smsBonusValues, flexiMinutesBonusValues } = useMemo(() => {
    const freeAddons = []
    const dataBonus = []
    const minutesBonus = []
    const smsBonus = []
    const flexiMinutesBonus = []
    const freePlanPromotions = planPromotions?.filter(promotion => promotion["Type"] === variables.PROMOTION_TYPE_FREE_PLAN);
    for (let promotion of freePlanPromotions) {
      const parsed = JSON.parse(promotion["Value"]);
      switch (parsed.Type) {
        case variables.PROMOTION_TYPE_VOICE_ON_NET:
        case variables.PROMOTION_TYPE_DATA_SOCIAL:
          freeAddons.push(parsed);
          break;
        case variables.PROMOTION_TYPE_DATA:
          dataBonus.push(parsed);
          break;
        case variables.PROMOTION_TYPE_VOICE_LCL:
          minutesBonus.push(parsed);
          break;
        case variables.PROMOTION_TYPE_VOICE_FLEXI:
          flexiMinutesBonus.push(parsed);
          break;
        case variables.PROMOTION_TYPE_SMS:
          smsBonus.push(parsed);
          break;
        default:
      }
    }

    for (let plans of savedPlans) {
      if (plans.Type === variables.PROMOTION_TYPE_DATA_SOCIAL) {
        freeAddons.push({ Type: plans.Type, Value: plans.Value });
      }
    }

    let dataBonusValues = Plans.getSumData(dataBonus, variables.PROMOTION_TYPE_DATA, "gb");
    let minutesBonusValues = Plans.getSumData(minutesBonus, variables.PROMOTION_TYPE_VOICE_LCL, "min");
    let flexiMinutesBonusValues = Plans.getSumData(flexiMinutesBonus, variables.PROMOTION_TYPE_VOICE_FLEXI, "min");
    let smsBonusValues = Plans.getSumData(smsBonus, variables.PROMOTION_TYPE_SMS, "sms");
    let addonsValues = Plans.getSumData(freeAddons, variables.PROMOTION_TYPE_DATA_SOCIAL, "gb")

    return { addonsValues, dataBonusValues, minutesBonusValues, smsBonusValues, flexiMinutesBonusValues }
  }, [planPromotions, savedPlans])

  const renderPlanDetailsAll = (plan) => {
    let content = null;
    let flagZero = 0;
    if (plan?.Unit === "sms") {
      // FOR "SMS-LCL"
      if (plan?.Value === -1 || smsBonusValues < 0) {
        flagZero = 1;
        content = <>
          {translationKeys["free_addons_unlimited"]}{" "}
          <span className="unit">{translationKeys[prefix_general + "sms_unit"]}</span>
        </>;
      } else {
        if (smsBonusValues > 0) {
          flagZero = 1;
          content = <>
            <span>{`(${storefront.getPlanDataMinValue(plan?.Value, plan?.Type)} + ${smsBonusValues}) = ${storefront.getPlanDataMinValue(plan?.Value, plan?.Type) + smsBonusValues}`}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "sms_unit"]}</span>
          </>;
        } else {
          flagZero = storefront.getPlanDataMinValue(plan?.Value, plan?.Type);
          content = <>
            <span>{storefront.getPlanDataMinValue(plan?.Value, plan?.Type)}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "sms_unit"]}</span>
          </>;
        }
      }
    }

    if (plan?.Unit === "bytes") {
      // FOR "DATA" & "DATA-SOCIAL"
      if (plan?.Value === -1 || dataBonusValues < 0) {
        flagZero = 1;
        content = <>
          {translationKeys["free_addons_unlimited"]}{" "}
          <span className="unit">{translationKeys[prefix_general + "data_unit"]}</span>
        </>;
      } else {
        if (dataBonusValues > 0) {
          flagZero = 1;
          content = <>
            <span>{`(${storefront.getPlanDataMinValue(plan?.Value, plan?.Type)} + ${dataBonusValues}) = ${storefront.getPlanDataMinValue(plan?.Value, plan?.Type) + dataBonusValues}`}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "data_unit"]}</span>
          </>;
        } else {
          flagZero = storefront.getPlanDataMinValue(plan?.Value, plan?.Type);
          content = <>
            <span>{storefront.getPlanDataMinValue(plan?.Value, plan?.Type)}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "data_unit"]}</span>
          </>;
        }
      }
    }

    if (plan?.Unit === "milliseconds" && plan?.Type !== variables.PROMOTION_TYPE_VOICE_FLEXI) {
      // For "VOICE-LCL"
      if (plan?.Value === -1 || minutesBonusValues < 0) {
        flagZero = 1;
        content = <>
          {translationKeys["free_addons_unlimited"]}{" "}
          <span className="unit">{translationKeys[prefix_general + "minute_unit"]}</span>
        </>;
      } else {
        if (minutesBonusValues > 0) {
          flagZero = 1;
          content = <>
            <span>{`(${storefront.getPlanDataMinValue(plan?.Value, plan?.Type)} + ${minutesBonusValues}) = ${storefront.getPlanDataMinValue(plan?.Value, plan?.Type) + minutesBonusValues}`}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "minute_unit"]}</span>
          </>;
        } else {
          flagZero = storefront.getPlanDataMinValue(plan?.Value, plan?.Type);
          content = <>
            <span>{storefront.getPlanDataMinValue(plan?.Value, plan?.Type)}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "minute_unit"]}</span>
          </>;
        }
      }
    }

    if (plan?.Unit === "milliseconds" && plan?.Type === variables.PROMOTION_TYPE_VOICE_FLEXI) {
      // For "VOICE-FLEXI"
      if (plan?.Value === -1 || flexiMinutesBonusValues < 0) {
        flagZero = 1;
        content = <>
          {translationKeys["free_addons_unlimited"]}{" "}
          <span className="unit">{translationKeys[prefix_general + "minutes_unit"] || translationKeys[prefix_general + "minute_unit"]}</span>
        </>;
      } else {
        if (flexiMinutesBonusValues > 0) {
          flagZero = 1;
          content = <>
            <span>{`(${storefront.getPlanDataMinValue(plan?.Value, plan?.Type)} + ${flexiMinutesBonusValues}) = ${storefront.getPlanDataMinValue(plan?.Value, plan?.Type) + flexiMinutesBonusValues}`}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "minutes_unit"] || translationKeys[prefix_general + "minute_unit"]}</span>
          </>;
        } else {
          flagZero = storefront.getPlanDataMinValue(plan?.Value, plan?.Type);
          content = <>
            <span>{storefront.getPlanDataMinValue(plan?.Value, plan?.Type)}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "minutes_unit"] || translationKeys[prefix_general + "minute_unit"]}</span>
          </>;
        }
      }
    }
    const planValueObj = {
      content: content,
      flagZero: flagZero
    } 
    return planValueObj;
  }

  const getVatPercentage = () => {
    let vat_percentage = JSON.parse(Storage.get("business", true))[
      "vat_percentage"
    ];
    return vat_percentage || 0
  }

  const checkPaymentSummary = ( sumData ) => {
    try {
      let sumPC = sumData?.saved_plans[0]?.ProductCode;
      let isPostPaid = Helpers.isPlanPostPaidDynamic(sumPC);
      if(isPostPaid) {
        let flags = Storage.get("flags", true);
        if(flags?.IsEligible) {
          return true; 
        } else {
          return false;  
        }
      } else {
        return true;
      }
    } catch (error) {
        console.error("Error occurred:", error);
    }
    return true
  }

  const validityKey = planFG.checkValiditySummary(summaryData);

  const egyptFlexSummarySource = useMemo(
    () => Helpers.resolveEgyptFlexSummarySource(savedPlanBundle, planPrice),
    [savedPlanBundle, planPrice]
  );

  const commonRecordFirebaseEvent = ({event_category, event_screen, event_label = "", interaction_type = "", ...properties }) => {
    const event_params = {
      event_category,
      event_screen,
      event_label,
      interaction_type,
      ...properties
    }
    FirebaseAnalytics.commonFunction(event_params)
  }
  
  return (
    loader ? (
      <StmSummarySkeleton />
    ) : (
      <>
        <div className="summary-stm-main">
          <div className="summary-stm-wrapper">
            <div className="stm-sum-grid stm-sum-grid-top">
              <h3 className="stm-sum-block-left">
                {translationKeys[prefix + "summary"]}
              </h3>

              {!!pdfUrl && <div className="package-btn">
                <button className="package-btn"
                  onClick={() => {
                    commonRecordFirebaseEvent({ event_category: "onboarding_payment", event_screen: "payment_summary", event_label: "package_card", interaction_type: "click" });
                    FirebaseAnalytics.button_clicked(
                      prefix + "package_card"
                    )
                    if(pdfPlanIDs) {
                      let firebase_param = {
                        plan_ids: pdfPlanIDs
                      }
                      FirebaseAnalytics.summary_package_card(firebase_param);
                    }
                  }}>
                  <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                    {translationKeys[prefix + "package_card"]}
                  </a>
                </button>
              </div>}
            </div>
            <p className="desc">{translationKeys[prefix + "num_disc"]}</p>
            <div className="stm-sum-data-box">
              {numberData && (
                <>
                  <div className="stm-sum-grid">
                    <div className="stm-sum-block-left stm-sum-logo">
                      <img src={Call} alt="call" />
                      <span>{translationKeys[prefix + "your_number"]}</span>
                    </div>
                    <div className="stm-sum-block-right">{numberData?.Price > 0 ? `${numberData?.Price} ${translationKeys[prefix_general + "currency"]}` : translationKeys[prefix + "free"]}</div>

                    <div className="stm-sum-block-left">{numberType}</div>
                    <div className="stm-sum-block-right">{numberData?.MSISDN}</div>
                  </div>
                  <hr />
                </>
              )}
              {egyptFlexSummarySource ? (
                <>
                  <EgyptFlexSummaryPlan
                    plan={egyptFlexSummarySource.plan}
                    price={egyptFlexSummarySource.price}
                  />
                  <div className="stm-sum-grid stm-sum-grid-plan-details">
                    <StmSummaryAmanFeatureRows
                      planCode={planCode}
                      planId={summaryData?.saved_plans?.[0]?.ID}
                      featureAttributes={summaryData?.saved_plans?.[0]?.FeatureAttributes}
                    />
                  </div>
                  <hr />
                </>
              ) : (
                !!savedPlans.length && (
                  <>
                    <div className="stm-sum-grid stm-sum-grid-plan-details">
                      <div className="stm-sum-block-left stm-sum-logo">
                        <img src={Data} alt="" />
                        <span className="plan-name">{Helpers.nextLineText(getPlanName(planCode) || planCode || translationKeys["general_plan_custom"], "span")}</span>
                      </div>
                      <div className="stm-sum-block-right">
                        {planPrice}{" "}
                        {" " + translationKeys[prefix_general + "currency"]}
                      </div>

                      {savedPlans.map((plan) => {
                        const contentService = Helpers.getStreaminService();
                        if (plan?.Type !== variables.PROMOTION_TYPE_DATA_SOCIAL  && 
                          !contentService?.includes(plan?.Type?.toLowerCase())
                        ) {
                          return (
                            renderPlanDetailsAll(plan)?.flagZero > 0 ?
                            <React.Fragment key={plan.ID}>
                              <div className="stm-sum-block-left">
                                {translationKeys[prefix_general +
                                  plan?.Type.replaceAll("-", "_").replaceAll(" ", "").toLowerCase()]
                                  ? translationKeys[prefix_general + plan?.Type.replaceAll("-", "_")
                                    .replaceAll(" ", "").toLowerCase()] : plan?.Type}
                              </div>
                              <div className="stm-sum-block-right">
                                {renderPlanDetailsAll(plan)?.content}
                              </div>
                            </React.Fragment>  : "")
                        } else {
                          return ""
                        }
                      })}

                      {addonsValues !== 0 &&
                        <>
                          <div className="stm-sum-block-left">
                            {Translations.keys['stm_general_data_social']}
                          </div>
                          <div className="stm-sum-block-right">
                            {addonsValues === -1 ? translationKeys["free_addons_unlimited"] : addonsValues}{" "}<span className="unit">{translationKeys[prefix_general + "data_unit"]}</span>
                          </div>
                        </>}

                        {translationKeys[validityKey] &&
                        <>
                          <div className="stm-sum-block-left" data-key={validityKey}>
                            {Translations.keys['scr_3.2_Plans_validity'] || "Validity"}
                          </div>
                          <div className="stm-sum-block-right">
                            {translationKeys[validityKey]}
                          </div>
                        </>}

                    </div>
                    <hr />
                  </>
                )
              )}

              {flexiCountries.length > 0 && !egyptFlexSummarySource && (
                <AvailableCountries countries={flexiCountries} type="summary" />
              )}

              {summaryData?.saved_plans && checkPaymentSummary(summaryData) ? <>
              {summaryData && summaryData.advance_payment > 0 ?
                <>
                  <div className="stm-sum-deposit-grid">
                    <div className="stm-sum-deposit-grid-common">
                      <div className="stm-sum-deposit-grid-common">
                          <img src={Wallet} alt="" />
                        <span>{Translations.keys['stm_summary_advance_payment']}</span>
                      </div>
                      <div>
                        <button
                          className="storefront-lean-button"
                          onClick={(e) => handleModalData(e, "deposit_payment_popup_json")}
                        >
                          {Translations.keys['stm_summary_advance_payment_learn_more']}
                        </button>
                      </div>
                    </div>
                    <div className="stm-sum-deposit-grid-common">
                      <div>{Translations.keys['stm_plan_adv_payment']}</div>
                      <div>{summaryData?.advance_payment}{" "}{Translations.keys['stm_general_currency']}</div>
                    </div>
                    <div>
                      <img src={Bulb} alt="" />
                      <p>{Translations.keys['stm_plan_adv_payment_desc']}</p>
                    </div>
                  </div>
                  <hr />
                </>
                : null}
              </> : ""}

              {summaryData?.saved_plans && checkPaymentSummary(summaryData) ? <>
              {summaryData && summaryData.deposit > 0 ?
                <>
                  <div className="stm-sum-deposit-grid">
                    <div className="stm-sum-deposit-grid-common">
                      <div className="stm-sum-deposit-grid-common">
                          <img src={Wallet} alt="" />
                        <span>{Translations.keys['stm_summary_deposit_payment']}</span>
                      </div>
                      <div>
                        <button
                          className="storefront-lean-button"
                          onClick={(e) => handleModalData(e, "advance_payment_popup_json")}
                        >
                          {Translations.keys['stm_summary_deposit_payment_learn_more']}
                        </button>
                      </div>
                    </div>
                    <div className="stm-sum-deposit-grid-common">
                      <div>{Translations.keys['stm_plan_dep_payment']}</div>
                      <div>{summaryData.deposit}{" "}{Translations.keys['stm_general_currency']}</div>
                    </div>
                    <div>
                      <img src={Bulb} alt="" />
                      <p>{Translations.keys['stm_plan_dep_payment_desc']}</p>
                    </div>
                  </div>
                  <hr />
                </>
                : null}
              </> : ""}

              <div className="stm-sum-content-title">
                <div className="stm-sum-block-left stm-sum-logo">
                  <img src={Tag} alt="" />
                  <span>{translationKeys[prefix + "offers"]}</span>
                </div>
              </div>
              <SummaryOfferSection
                getSummary={getSummary}
                selectedCard={selectedCard}
                appliedOffer={appliedOffer}
                setAppliedOffer={setAppliedOffer}
                setOffersFetchedInitially={setOffersFetchedInitially}
                firebaseEventParamsOnToggle={socFirebaseEventParamsOnToggle}
                firebaseEventParamsOnApply={socFirebaseEventParamsOnApply}
                firebaseEventParamsOnError={socFirebaseEventParamsOnError}
              />
              {summaryData?.saved_plans && checkPaymentSummary(summaryData) ? <>
                {summaryData?.total_amount_vat_excluded ? <hr /> : null}
                <div className="stm-sum-grid  stm-sum-grid-payment">
                  {summaryData?.total_amount_vat_excluded ?
                  <>
                    <div className="payment-sum-right">
                      {translationKeys[prefix + "payment_amount"]}
                    </div>
                    <div className="payment-sum-left">
                      {summaryData?.total_amount_vat_excluded}{" "}
                      {" " + translationKeys[prefix_general + "currency"]}
                    </div>
                  </> : null}

                  {summaryData?.vat_amount > 0 && summaryData?.total_amount_vat_excluded ?
                  <>
                  <div className="payment-sum-right">
                    {translationKeys[prefix + "vat"]}
                      {getVatPercentage() ? ` (${getVatPercentage()}%) ` : null}
                  </div>
                  <div className="payment-sum-left">
                    {summaryData?.vat_amount}
                    {" " + translationKeys[prefix_general + "currency"]}{" "}
                  </div>
                  </> : null}

                  {summaryData?.total_amount_vat_included ?
                  <>
                    <div className="stm-sum-block-left stm-sum-logo sum-total-amt">
                      {translationKeys[prefix + "total_amount"]}
                    </div>
                    <div className="stm-sum-block-right sum-total-amt">
                      {summaryData?.total_amount_vat_included}{" "}
                      {" " + translationKeys[prefix_general + "currency"]}
                    </div>
                  </> : null}
                </div>
              </> : ""}
            </div>
            {summaryData && summaryData.credit_limit > 0 ?
              <div className="stm-sum-credit-box">
                <img src={Bulb} alt="" />
                <div>
                  <p>{translationKeys["stm_credit_limit_desc1"]}{" "}{summaryData?.credit_limit}{" "}{translationKeys[prefix_general + "currency"]}. {translationKeys["stm_credit_limit_desc2"]}</p>
                  <button
                    className="storefront-lean-button"
                    onClick={(e) => handleModalData(e, "credit_limit_popup_json")}
                  >
                    {translationKeys["stm_summary_credit_learn_more"]}
                  </button>
                </div>
              </div>
              : ""}
          </div>    </div>
        {openModal &&
          <ModalWrapper handleToggleModal={handleModal}>
            <ContentSlider
              imagesFolder={infoModalDetails?.imagesFolder}
              sliderData={infoModalDetails?.sliderData}
              closeModal={handleModal}
            />
          </ModalWrapper>
        }
      </>
    )
  );
};

export default StmSummary;
